// src/plugins/http.js
import Vue from "vue";
import axios from "axios";

// Resolve a base da API em runtime:
// 1) env.js (window.__ENV.API_BASE)
// 2) .env.* (process.env.VUE_APP_API_BASE)
// 3) Fallback: localhost/127.0.0.1 -> api-admin.flexcard.info; caso contrário -> /api

function resolveApiBase() {
  const isLocal =
    typeof location !== "undefined" &&
    (location.hostname === "localhost" || location.hostname === "127.0.0.1");

  // 1) Em DEV LOCAL: ignore window.__ENV e use .env.development ou fallback fixo
  if (isLocal) {
    const devBase =
      (typeof process !== "undefined" &&
        process.env &&
        process.env.VUE_APP_API_BASE) ||
      "";
    return devBase || "https://api-admin.flexcard.info";
  }

  // 2) Em PRODUÇÃO (ou não-local): siga a ordem normal
  try {
    if (
      typeof window !== "undefined" &&
      window.__ENV &&
      window.__ENV.API_BASE
    ) {
      return window.__ENV.API_BASE; // geralmente "/api" no Hostinger
    }
  } catch (e) {
    // silencioso
  }

  const envBase =
    (typeof process !== "undefined" &&
      process.env &&
      process.env.VUE_APP_API_BASE) ||
    "";

  if (envBase) return envBase;

  return "/api";
}

const http = axios.create({
  baseURL: resolveApiBase(),
  timeout: 15000,
  withCredentials: false,
});

// Interceptor para anexar Authorization sempre que houver token no storage
http.interceptors.request.use(
  (cfg) => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = token;
      }
    } catch (e) {
      // silencioso
    }
    return cfg;
  },
  (err) => Promise.reject(err)
);

// Exporta e injeta no Vue
Vue.prototype.$http = http;
export default http;
